module.exports = __webpack_public_path__ + "assets/img/logo3.fa8d7e3f.png";